import { InsufficientStockItem } from '../../models';
import { Button } from '../../components/ui/Button';
import { CHECKOUT_PRIMARY_ACTION_CLASS } from './styles';
import { AlertTriangleIcon, CheckCircleIcon } from '../../components/ui/Icons';

interface StockConflictNoticeProps {
  items: InsufficientStockItem[];
  applied: boolean;
  onApply: () => void;
  onDismiss: () => void;
}

function describeItem(item: InsufficientStockItem, applied: boolean) {
  if (item.available <= 0) {
    return applied ? `${item.description}: removido da sacola (esgotado)` : `${item.description}: esgotado`;
  }
  const pieces = item.available === 1 ? 'peça' : 'peças';
  return applied
    ? `${item.description}: quantidade ajustada para ${item.available}`
    : `${item.description}: só restam ${item.available} ${pieces}`;
}

export function StockConflictNotice({ items, applied, onApply, onDismiss }: StockConflictNoticeProps) {
  const Icon = applied ? CheckCircleIcon : AlertTriangleIcon;
  const title = applied
    ? 'Sacola ajustada'
    : 'Algumas peças acabaram de ser reservadas ou vendidas';
  const subtitle = applied
    ? 'Confira o que mudou e, se estiver tudo certo, finalize novamente.'
    : 'Ajuste a sacola para continuar com as peças que ainda estão disponíveis.';

  return (
    <div
      role="alert"
      className={[
        'rounded-2xl border p-4 sm:p-5 mb-4 sm:mb-6',
        applied ? 'bg-olivine/10 border-olivine-dark/40' : 'bg-warning/15 border-warning/60',
      ].join(' ')}
    >
      <div className="flex items-start gap-3">
        <Icon className={['w-6 h-6 shrink-0 mt-0.5', applied ? 'text-olivine-dark' : 'text-text-dark'].join(' ')} />
        <div className="min-w-0 flex-1">
          <p className="text-sm font-semibold text-text-dark">{title}</p>
          <p className="text-sm text-text-medium mt-0.5">{subtitle}</p>
          <ul className="mt-3 space-y-1.5">
            {items.map((item) => (
              <li key={item.productVariantId} className="text-sm text-text-dark break-words">
                {describeItem(item, applied)}
              </li>
            ))}
          </ul>
          <div className="mt-4 flex flex-col sm:flex-row gap-2">
            {!applied && (
              <Button onClick={onApply} className={`w-full sm:w-auto ${CHECKOUT_PRIMARY_ACTION_CLASS}`}>
                Ajustar minha sacola
              </Button>
            )}
            <Button variant="outline" onClick={onDismiss} className="w-full sm:w-auto">
              {applied ? 'Entendi' : 'Fechar'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
